import { useState } from 'react';
import { useLookups } from '../../context/LookupsContext';
import { useReloadAlerts } from '../../context/AlertsContext';
import { expensesApi } from '../../api';
import he from '../../i18n/he';
import DataTable from '../../components/DataTable';
import Button from '../../components/Button';
import ExpenseModal from '../../components/ExpenseModal';
import MarkPaidModal from '../../components/MarkPaidModal';
import PayerCell from '../../components/PayerCell';
import { payersLine } from '../../utils/payers';
import { expenseAmountColumns } from '../../components/expenseAmountColumns';
import ExpenseActions from '../../components/ExpenseActions';

export default function ExpensesPanel({ job, onChange }) {
  const lookups = useLookups();
  const [editing, setEditing] = useState(null); // expense row, {} for new, or null
  const [paying, setPaying] = useState(null); // the unpaid expense being settled
  const reloadAlerts = useReloadAlerts();

  // A deleted cost may have been a charge waiting to be raised — the money dot's amber.
  const remove = async (row) => {
    await expensesApi.remove(row.id);
    onChange();
    reloadAlerts();
  };

  const columns = [
    { key: 'category', label: he.jobs.category, primary: true, render: (r) => lookups.categoryLabel(r.category) },
    { key: 'description', label: he.jobs.description, render: (r) => r.description || '—' },
    // What we asked the client for, what it cost us, and who bears it in the end — read
    // together, right to left. The assessed value of goods is reporting-only and stays in
    // the expense dialog, not here.
    ...expenseAmountColumns,
    // An unpaid expense shows its state here instead of a payer. The job's cost total
    // still includes it — it is a real cost; it just hasn't moved anyone's money.
    { key: 'payers', label: he.jobs.payer, render: (r) => <PayerCell expense={r} />, sortValue: (r) => payersLine(r.payers) },
    { key: 'action', label: he.common.actions, action: true, render: (r) => (
      <ExpenseActions expense={r} onMarkPaid={setPaying} onEdit={setEditing} onDelete={remove} />
    ) },
  ];

  return (
    <div className="card w-section">
      <div className="w-head">
        <h2>{he.jobs.expensesList}</h2>
        <Button small variant="ghost" onClick={() => setEditing({})}>{he.jobs.addExpense}</Button>
      </div>
      <DataTable
        columns={columns}
        rows={job.expenses}
        empty={{ text: he.jobs.emptyExpenses }}
      />
      {editing && (
        <ExpenseModal
          jobId={job.id}
          expense={editing}
          owner={{ title: job.title, clientName: job.client_name }}
          onClose={() => setEditing(null)}
          onSaved={() => { setEditing(null); onChange(); }}
        />
      )}
      {paying && (
        <MarkPaidModal
          expense={paying}
          onClose={() => setPaying(null)}
          onSaved={() => { setPaying(null); onChange(); }}
        />
      )}
    </div>
  );
}
